export enum NoApplicationErrorMessage {
  errorMessage = 'No applications found',
}
